import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class Intro extends Component() {
		mounted() {
			this.circle = this.el.querySelector(
				".c-intro__circle .c-circle__fill"
			);
			this.content = this.el.querySelector(".c-intro__content");
		}

		animations() {
			gsap.set(this.circle, {
				scale: 0,
				transformOrigin: "50% 50%",
			});

			gsap.set(this.content, {
				y: "20px",
				opacity: 0,
			});

			this.anim = gsap.timeline();

			this.anim.to(
				this.circle,
				{
					scale: 1,
					ease: "back.out",
					duration: 1.05,
				},
				0.2
			);

			this.anim.to(
				this.content,
				{
					y: 0,
					opacity: 1,
					ease: "sine.out",
					duration: 0.6,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
